import SignInForm from "../../components/common/auth/SignInForm";
import AuthLayout from "./AuthPageLayout";
import { usePageMeta } from "../../hooks/usePageMeta";
import { PAGE_METADATA } from "../../config/pageMetadata";

export default function SignIn() {
  usePageMeta(PAGE_METADATA.login);

  return (
    <AuthLayout>
      <SignInForm />
    </AuthLayout>
  );
}
